import { SelectTypes } from '@genial/components';
import type { ReportingEnumsReportingFilePeriodEnum } from '@genial/services/dist/models';

const reportingFilePeriodById: Record<number, ReportingEnumsReportingFilePeriodEnum> = {
  0: 'Last30Days',
  1: 'CurrentMonth',
  2: 'PreviousMonth',
  3: 'ReferenceDate',
};

const fallbackPeriodLabels: Record<ReportingEnumsReportingFilePeriodEnum, string> = {
  Last30Days: 'Últimos 30 dias',
  CurrentMonth: 'Mês atual (até D-1)',
  PreviousMonth: 'Mês fechado (Anterior)',
  ReferenceDate: 'Data de referência',
};

const getReportingFilePeriodFromId = (
  id: number
): ReportingEnumsReportingFilePeriodEnum | undefined => reportingFilePeriodById[id];

export const getReportingFilePeriodLabel = (
  period: ReportingEnumsReportingFilePeriodEnum | undefined,
  apiLabel?: string | null
): string => {
  if (apiLabel?.trim()) {
    return apiLabel.trim();
  }

  if (!period) {
    return '--';
  }

  return fallbackPeriodLabels[period] ?? period;
};

export const mapSupportedPeriodsToOptions = (
  periods: Array<{ id: number; label?: string | null }> | null | undefined
): SelectTypes.Option[] => {
  if (!periods?.length) {
    return [];
  }

  return periods.reduce<SelectTypes.Option[]>((options, period) => {
    const value = getReportingFilePeriodFromId(period.id);
    if (!value) {
      return options;
    }

    options.push({
      value,
      label: getReportingFilePeriodLabel(value, period.label),
    });

    return options;
  }, []);
};

export const isReferenceDatePeriod = (
  period: ReportingEnumsReportingFilePeriodEnum | undefined
): boolean => period === 'ReferenceDate';
